import type { MediaFile, Person, Tag } from "@/types/movies";
import type { CastMember } from "@/types/movie";

export function formatDuration(str: string): string {
  if (!str) return "";
  const [h, m] = str.split(":").map(Number);
  const parts: string[] = [];
  if (h) parts.push(`${h} ساعت`);
  if (m) parts.push(`${m} دقیقه`);
  return parts.join(" و ");
}

export function deriveYear(release_date?: string | null): string {
  return release_date ? String(new Date(release_date).getFullYear()) : "";
}

export function deriveCountries(tags?: Tag[]): Tag[] {
  return (tags ?? []).filter((t) => t?.type === "کشور");
}

export function deriveGenres(tags?: Tag[]): Tag[] {
  return (tags ?? []).filter((t) => t?.type === "ژانر");
}

export function deriveSubtitleLabel(
  hasSubtitles: boolean,
  hasDubs: boolean,
): string {
  if (hasSubtitles && hasDubs) return "زیرنویس - دوبله";
  if (hasSubtitles) return "زیرنویس";
  if (hasDubs) return "دوبله";
  return "";
}

export interface BackgroundImages {
  mobile: string;
  tablet: string;
  desktop: string;
}

export function mapBackgroundImages(medias: MediaFile[] = []): BackgroundImages {
  return {
    mobile: medias.find((m) => m?.media_type === "backdrop_mobile")?.media_url ?? "",
    tablet: medias.find((m) => m?.media_type === "backdrop_tablet")?.media_url ?? "",
    desktop:
      medias.find((m) => m?.media_type === "backdrop_desktop")?.media_url ??
      medias.find((m) => m?.media_type === "poster_desktop")?.media_url ??
      "",
  };
}

export function mapCast(persons: Person[] = []): CastMember[] {
  return persons.map((p, index) => ({
    uuid: p?.uuid ?? `person-${index}`,
    name_fa: p?.name_fa ?? p?.name_en ?? "—",
    name_en: p?.name_en ?? p?.name_fa ?? "—",
    photo_url: p?.photo_url ?? "",
    role: p?.role ?? "",
    order_index: p?.order_index ?? index,
  }));
}

export function findDirectorName(persons: Person[] = []): string {
  return (
    persons.find((p) => p.role === "directors" || p.role === "کارگردان")
      ?.name_fa ?? ""
  );
}
